import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencilAlt } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ContactSaisie from "./ContactSaisie";

const ContactConfirmation = ({ onConfirm, formData, setFormData }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [code, setCode] = useState("");
  const [generatedCode] = useState(Math.random().toString(36).substr(2, 6));
  
  const handleSubmit = (e) => {
    e.preventDefault();
    if (code === generatedCode) {
      onConfirm(); // Envoie l'email
    
    } else {
      toast.error("Le code saisi est incorrect !", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });

      console.log("Le code saisi est incorrect ! "+code+" != "+generatedCode);
      // onConfirm(); // Envoie l'email
    }
  };

  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleEditSubmit = (updatedData) => {
    setFormData(updatedData); // Update the state with the new data
    setIsEditing(false); // Exit editing mode
  };

  return isEditing  ? (
        <ContactSaisie 
          onSubmit={handleEditSubmit} // Ensure `onSubmit` is passed here
          field={formData} // Pré-remplissage
        />
      )
      : 
      (
      <div className="container-fluid py-5 bg-violet-foncee">
        <div className="bg-violet-claire container py-5 rounded">
        <h2 className="text-center">Confirmez vos informations</h2>
        <ul className="list-group">
        <li className="list-group-item d-flex justify-content-between align-items-center">
          <div>Nom : <strong>{formData.user_name}</strong></div>
          <button
            className="btn btn-link p-0 text-primary"
            onClick={() => handleEdit("user_name")}
            title="Modifier"
          >
            <FontAwesomeIcon icon={faPencilAlt} />
          </button>
        </li>
          <li className="list-group-item d-flex justify-content-between align-items-center">
            <div>Nom : <strong>{formData.user_email}</strong></div>
              <button
              className="btn btn-link p-0 text-primary"
              onClick={() => handleEdit("user_email")}
              title="Modifier"
              >
                <FontAwesomeIcon icon={faPencilAlt} />
              </button>
            </li>
            <li className="list-group-item d-flex justify-content-between align-items-center">
              <div>Nom : <strong>{formData.message}</strong></div>
                <button
                className="btn btn-link p-0 text-primary"
                onClick={() => handleEdit("message")}
                title="Modifier"
              >
               <FontAwesomeIcon icon={faPencilAlt} />
              </button>
            </li>
          </ul>
          <form onSubmit={handleSubmit} className="mt-4">
          <div className="mb-3">
          <label htmlFor="code" className="form-label">
          Recopiez ce code : <strong>{generatedCode}</strong>
          </label>
          <input
            type="text"
            className="form-control"
            id="code"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            placeholder="Recopiez ici le code"
            required
          />
          </div>
          <button type="submit" className="btn btn-primary w-100">
            Confirmer l'envoi de votre mail
          </button>
          </form>
        </div>
      </div>
      );
};

export default ContactConfirmation;
